export var getTheme = function getTheme(theme) {
  return require("./".concat(theme, ".module.css"));
};